// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.enabled[data-v-0f4ec31f] {\n  color: #348eca;\n  cursor: pointer;\n}\n.disabled[data-v-0f4ec31f] {\n  color: grey;\n  pointer-events: none;\n}\n", ""]);
// Exports
module.exports = exports;
